import {
	Box,
	Button,
	Checkbox,
	InputAdornment,
	MenuItem,
	Modal,
	Select,
	Skeleton,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TextField,
	Tooltip,
	Typography,
} from "@mui/material";
import {
	ArrowRight,
	Check,
	ChevronDown,
	ChevronLeft,
	ChevronRight,
	ChevronUp,
	Plus,
	Repeat,
	Search,
	Trash2,
} from "lucide-react";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { URI_API, getHeaders } from "../../utils/config";
import capitalize from "../../../src/utils/capitalize";
import { ToastContainer, toast } from "react-toastify";
import { LoggedUser } from "../../store/interfaces";
import { AppState, setIsPatientsEnabled, setPageState } from "../../store/reducer";
import Shift from "../../utils/shiftFunctions";
import { useDispatch, useSelector } from "react-redux";
import "./AssistanceAdjustList.scss";
import moment from "moment";
import AddNurseModal from "../../widgets/AssistanceAdjustModals/addNurseModal/addNurseModal";
import MoveNurseModal from "../../widgets/AssistanceAdjustModals/moveNurseModal/moveNurseModal";
import ReplaceNurseModal from "../../widgets/AssistanceAdjustModals/replaceNurseModal/replaceNurseModal";
import DeleteNurseModal from "../../widgets/AssistanceAdjustModals/deleteNurseModal/deleteNurseModal";
import ConfirmationModal from "../../widgets/ConfirmationModal/ConfirmationModal";
import { AssistanceAdjustContext } from "../AssistanceAdjust/AssistanceAdjust";
import { Dispatch } from "redux";
import { PageState } from "../../views/Home/HomeUtils";
import { Position } from "../../views/Login/LoginUtils";
import CustomSnackbar, { SnackbarModes } from "../../widgets/Snackbars/Snackbar/Snackbar";

export const AssitanceAdjustViewContext = createContext<any>({
	calendarDays: [],
	setCalendarDays: () => {},
	nursesByDay: [],
	nurses: [],
	setNurses: () => {},
	selected: {},
	setSelected: () => {},
	selectedShift: {},
	setSelectedShift: () => {},
	shifts: [],
	availableNurses: {},
	setAvailableNurses: () => {},
	availableAreas: {},
	setAvailableAreas: () => {},
	selectedNurse: "",
	setSelectedNurse: () => {},
	selectedNurses: [],
	setSelectedNurses: () => {},
	selectedArea: "",
	setSelectedArea: () => {},
	onItemSelected: () => {},
	selectedReason: "",
	setSelectedReason: () => {},
	replacementNurse: "",
	setReplacementNurse: () => {},
	modalHeader: "",
	setModalHeader: () => {},
	clearFieldsNClose: () => {},
	isModalLoading: "",
	setIsModalLoading: () => {},
	saveMovements: () => {},
	showModal: "",
	setShowModal: () => {},
});

export default function AssistanceAdjustList() {
	const [nurses, setNurses] = useState<any>([]);

	const [filteredNurses, setFilteredNurses] = useState(nurses);
	const [areas, setAreas] = useState([]);
	const [sortConfig, setSortConfig] = useState<{ key: string; direction: "asc" | "desc" } | null>(
		null,
	);
	const [areaFilterSelected, setAreaFilterSelected] = useState("");
	const [availableNurses, setAvailableNurses] = useState<any>([]);
	const [selectedReason, setSelectedReason] = useState<any>("");
	const [selectedNurses, setSelectedNurses] = useState<any>([]);
	const [availableAreas, setAvailableAreas] = useState<any>([]);
	const [replacementNurse, setReplacementNurse] = useState("");
	const [selectedShift, setSelectedShift] = useState<any>(null);
	const [duplicateNurse, setDuplicateNurse] = useState(false);
	const [selectedNurse, setSelectedNurse] = useState<any>("");
	const [canScrollRight, setCanScrollRight] = useState(true);
	const [calendarDays, setCalendarDays] = useState<any>([]);
	const [canScrollLeft, setCanScrollLeft] = useState(false);
	const [selectedArea, setSelectedArea] = useState<any>("");
	const containerRef = useRef<HTMLDivElement>(null);
	const [isNursesLoading, setIsNursesLoading] = useState(true);
	const [isLoading, setIsLoading] = useState(true);
	const [shifts, setShifts] = useState<any>([]);
	const [showModal, setShowModal] = useState(false);
	const [modalHeader, setModalHeader] = useState("Agregar Profesional");
	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	const [isModalLoading, setIsModalLoading] = useState(false);
	const [confirmationTitle, setConfirmationTitle] = useState("");
	const [openSnackbar, setOpenSnackbar] = useState(false);

	const { selected, setSelected } = useContext(AssistanceAdjustContext);

	const loggedUser: LoggedUser = useSelector((state: AppState) => state.loggedUser);

	const dispatch: Dispatch<any> = useDispatch();

	useEffect(() => {
		fetch(`${URI_API}/nurses`, getHeaders())
			.then((res) => res.json())
			.then((body) => setAvailableNurses(body));

		fetch(`${URI_API}/all_areas`, getHeaders())
			.then((res) => res.json())
			.then((body) => setAvailableAreas(body));

		fetch(`${URI_API}/session_user_areas`, getHeaders())
			.then((res) => res.json())
			.then((body) => {
				const uniqueAreas = body
					.filter(
						(obj: any, index: any, self: any) =>
							index === self.findIndex((a: any) => a.area === obj.area),
					)
					.filter((area: any) => area.area !== "SOPORTE");
				setAreas(uniqueAreas);
			});

		const schedules_endpoint =
			loggedUser.position === Position.SUPER
				? "all_work_schedule_names"
				: "work_schedule_names";

		// Obtain all Work Schedule (Shifts)
		fetch(`${URI_API}/${schedules_endpoint}`, getHeaders())
			.then((res) => res.json())
			.then((body) => {
				let shifts = body;
				shifts = shifts.map((shift: any) => Shift.AsOption(shift));
				setShifts(shifts);
			});

		fetch(`${URI_API}/current_work_schedule_name`, getHeaders())
			.then((res) => res.json())
			.then((body) => {
				let currentShift = Shift.Current(body);
				currentShift = Shift.AsOption(currentShift);
				if (currentShift === null) {
					currentShift = { key: "matutino" };
				}
				setSelectedShift(currentShift);
				refreshNursesDataList(currentShift);
				setIsLoading(false);
			});
	}, []);

	useEffect(() => {
		setIsNursesLoading(true);
		refreshNursesDataList(selectedShift);
	}, [selected, selectedShift]);

	const refreshNursesDataList = (shift: any) => {
		const date = selected.getFullYear() + "-" +
              String(selected.getMonth() + 1).padStart(2, "0") + "-" +
              String(selected.getDate()).padStart(2, "0");
		if (shift !== null) {
			fetch(
				`${URI_API}/nursing_calendar/${date}/${shift.key}`,
				getHeaders(),
			)
				.then((res) => res.json())
				.then((body) => {
					setNurses(body);
					setFilteredNurses(body);
					setIsNursesLoading(false);
				});
		}
	};

	const changeShiftCombo = (shift: any) => {
		setSelectedShift({ key: shift });
	};

	const getDaysInMonth = (_date: any) => {
		let date = new Date(_date);
		let all_days = [];
		const month = date.getMonth();
		date.setDate(1);
		while (date.getMonth() === month) {
			const d = new Date(date);
			if (moment(new Date()).isSame(d, "day")) {
				setSelected(d);
			}
			all_days.push({
				day: d,
				selected: moment(new Date()).isSame(d, "day"),
			});
			date.setDate(date.getDate() + 1);
		}
		return all_days;
	};

	const checkScroll = () => {
		if (!containerRef.current) return;

		const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;

		setCanScrollLeft(scrollLeft > 0);
		setCanScrollRight(scrollLeft + clientWidth < scrollWidth);
	};

	const handleScroll = (direction: "left" | "right") => {
		if (!containerRef.current) return;

		const scrollAmount = containerRef.current.clientWidth;

		if (direction === "left") {
			containerRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
		} else {
			containerRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
		}

		setTimeout(checkScroll, 150);
	};

	const updateSelectedNurses = (id: string) => {
		setSelectedNurses((prevNurses: any) => {
			if (prevNurses.includes(id)) {
				return prevNurses.filter((nurse_id: string) => nurse_id !== id);
			} else {
				return [...prevNurses, id];
			}
		});
	};

	useEffect(() => {
		var filtered = nurses.filter(function (nurse: any) {
			if (areaFilterSelected === "") {
				return true;
			} else if (
				nurse.nursename.toLowerCase().includes(areaFilterSelected.toLowerCase()) ||
				nurse.classx.toLowerCase().includes(areaFilterSelected.toLowerCase()) ||
				nurse.vital_support.toLowerCase().includes(areaFilterSelected.toLowerCase()) ||
				nurse.area.toLowerCase().includes(areaFilterSelected.toLowerCase()) ||
				nurse.hospital_name.toLowerCase().includes(areaFilterSelected.toLowerCase())
			) {
				return true;
			}
			return false;
		});
		setFilteredNurses(filtered);
	}, [areaFilterSelected, nurses]);

	const areaFilter = (area: string) => {
		if (areaFilterSelected === area) {
			setAreaFilterSelected("");
		} else {
			setAreaFilterSelected(area);
		}
	};

	const handleSort = (key: string) => {
		let direction: "asc" | "desc" = "asc";

		if (sortConfig?.key === key && sortConfig.direction === "asc") {
			direction = "desc";
		}

		setSortConfig({ key, direction });

		const sortedData = [...filteredNurses].sort((a: any, b: any) => {
			const valueA = a[key] ? a[key].toString().toUpperCase() : "";
			const valueB = b[key] ? b[key].toString().toUpperCase() : "";

			if (valueA < valueB) return direction === "asc" ? -1 : 1;
			if (valueA > valueB) return direction === "asc" ? 1 : -1;
			return 0;
		});

		setFilteredNurses(sortedData);
	};

	const onItemSelected = (value?: any) => {
		setDuplicateNurse(false);
		setOpenSnackbar(false);
		setSelectedNurse(value?.id ?? "");

		if (value) {
			for (let i = 0; i < nurses.length; i++) {
				if (nurses[i].nurse_id === value.id) {
					setDuplicateNurse(true);
					setOpenSnackbar(true);
				}
			}
		}
	};

	const clearFieldsNClose = () => {
		setSelectedNurse("");
		setSelectedArea("");
		setSelectedArea("");
		setSelectedReason("");
		setReplacementNurse("");
		setSelectedNurses([]);
		setDuplicateNurse(false);
		setShowConfirmationModal(false);
		setShowModal(false);
		setOpenSnackbar(false);
	};

	const ModalOption = () => {
		let modalBody = <Box></Box>;
		switch (modalHeader) {
			case "Agregar Profesional":
				modalBody = <AddNurseModal />;
				break;
			case "Mover Profesional":
				modalBody = <MoveNurseModal />;
				break;
			case "Reemplazar Profesional":
				modalBody = <ReplaceNurseModal />;
				break;
			case "Eliminar Profesional":
				modalBody = <DeleteNurseModal />;
				break;
		}
		return (
			<>
				<Box className="assitance-modal-card__content">{modalBody}</Box>
			</>
		);
	};

	const endedSaving = () => {
		setShowModal(false);
		setIsModalLoading(false);
		refreshNursesDataList(selectedShift);
	};

	type SaveMovementsParams = {
		area: string;
		reason: string;
		newNurse: string;
		replace: string;
	};

	const saveMovements = (params: SaveMovementsParams) => {
		switch (modalHeader) {
			case "Agregar Profesional":
				createNurse(params.newNurse, params.area);
				break;
			case "Mover Profesional":
				moveNurse(params.area, params.reason);
				break;
			case "Reemplazar Profesional":
				replaceNurse(params.replace, params.area, params.reason);
				break;
			case "Eliminar Profesional":
				deleteNurse(params.reason);
				break;
		}
	};

	const createNurse = (newNurse: string, area: string) => {
		setSelectedNurse(newNurse);
		setSelectedArea(area);
		setIsModalLoading(true);
		const date = selected.getFullYear() + "-" +
              String(selected.getMonth() + 1).padStart(2, "0") + "-" +
              String(selected.getDate()).padStart(2, "0");
		if (duplicateNurse === true) {
			fetch(
				`${URI_API}/nursing_calendar_duplicate`,
				getHeaders("POST", {
					date: date,
					nurse_id: newNurse,
					schedulename: selectedShift.key,
					area_id: area,
				}),
			).then((res) => {
				if (res.status === 200) {
					endedSaving();
					setConfirmationTitle(modalHeader);
					setShowConfirmationModal(true);
				} else if (res.status === 406) {
					endedSaving();
					setConfirmationTitle("Error");
					setShowConfirmationModal(true);
				} else {
					endedSaving();
					setConfirmationTitle("Algo salió mal.");
					setShowConfirmationModal(true);
				}
			});
		} else {
			fetch(
				`${URI_API}/nursing_calendar`,
				getHeaders("POST", {
					date: date,
					nurse_id: newNurse,
					schedulename: selectedShift.key,
					area_id: area,
				}),
			).then((res) => {
				if (res.status === 200) {
					endedSaving();
					setConfirmationTitle(modalHeader);
					setShowConfirmationModal(true);
				} else {
					endedSaving();
					setConfirmationTitle("Algo salió mal.");
					setShowConfirmationModal(true);
				}
			});
		}
	};

	const moveNurse = (area: string, reason: string) => {
		setSelectedArea(area);
		setSelectedReason(reason);
		setIsModalLoading(true);
		fetch(
			`${URI_API}/nursing_calendar`,
			getHeaders("PUT", {
				id: selectedNurses[0],
				area_id: area,
				schedulename: selectedShift.key,
				comment: reason,
			}),
		).then((res) => {
			if (res.status === 200) {
				endedSaving();
				setConfirmationTitle(modalHeader);
				setShowConfirmationModal(true);
			} else {
				endedSaving();
				setConfirmationTitle("Algo salió mal.");
				setShowConfirmationModal(true);
			}
		});
	};

	const replaceNurse = (replace: string, area: string, reason: string) => {
		setReplacementNurse(replace);
		setSelectedArea(area);
		setSelectedReason(reason);
		setIsModalLoading(true);
		fetch(
			`${URI_API}/nursing_calendar/replace`,
			getHeaders("POST", {
				replaceid: selectedNurses[0],
				date: nurses.find((e: any) => e.id === selectedNurses[0]).date,
				schedulename: selectedShift.key,
				nurse_id: availableNurses.find((e: any) => e.id === replace).id,
				classx: availableNurses.find((e: any) => e.id === replace).class,
				area_id: area,
				comment: reason,
			}),
		)
			.then((res) => {
				if (res.status === 200) {
					setConfirmationTitle(modalHeader);
					setShowConfirmationModal(true);
				} else {
					setConfirmationTitle("Algo salió mal.");
					setShowConfirmationModal(true);
				}
			})
			.catch(() => {
				toast("Error al reemplazar profesional.", {
					type: "error",
					containerId: "AAV",
				});
			})
			.finally(() => {
				endedSaving();
			});
	};

	const deleteNurse = (reason: string) => {
		setIsModalLoading(true);
		const fetchs = selectedNurses.map((nurse_id: any) => {
			fetch(
				`${URI_API}/nursing_calendar`,
				getHeaders("DELETE", {
					id: nurse_id,
					comment: reason,
				}),
			).then((res) => res.json());
		});
		Promise.all(fetchs).then(() => {
			let _date = new Date();
			_date.setDate(1);
			_date.setHours(1, 0, 0, 0);
			setConfirmationTitle(modalHeader);
			setShowConfirmationModal(true);
			endedSaving();
			setSelectedNurses([]);
		});
	};

	return (
		<>
			<AssitanceAdjustViewContext.Provider
				value={{
					calendarDays,
					setCalendarDays,
					nurses,
					setNurses,
					selectedShift,
					setSelectedShift,
					shifts,
					availableNurses,
					setAvailableNurses,
					availableAreas,
					setAvailableAreas,
					selectedNurse,
					setSelectedNurse,
					selectedNurses,
					setSelectedNurses,
					selectedArea,
					setSelectedArea,
					selectedReason,
					setSelectedReason,
					replacementNurse,
					setReplacementNurse,
					modalHeader,
					setModalHeader,
					clearFieldsNClose,
					isModalLoading,
					setIsModalLoading,
					saveMovements,
					showModal,
					setShowModal,
					onItemSelected,
				}}
			>
				<Box className="adjust-list">
					<Box className="adjust-list__header">
						<Box className="adjust-list__header__titlerow">
							<Typography className="adjust-list__header__title">
								Ajustes de Asistencia
							</Typography>
							{selectedShift !== null ? (
								<Select
									size="small"
									className="adjust-list__header__select"
									MenuProps={{
										PaperProps: {
											className: "adjust-list__header__select-dropdown",
										},
									}}
									renderValue={(selected: any) => {
										return (
											<Box sx={{ display: "flex", flexDirection: "row" }}>
												<Typography className="adjust-list__header__schedule">
													Turno
												</Typography>
												<Typography className="adjust-list__header__select-text">
													{shifts.find((e: any) => e.key === selected)
														?.text || ""}
												</Typography>
											</Box>
										);
									}}
									value={selectedShift?.key}
									onChange={(e: any) => changeShiftCombo(e.target.value)}
								>
									{shifts.map((shift: any) => {
										return (
											<MenuItem
												className="adjust-list__header__select-menuitem"
												value={shift.key}
											>
												{shift.text}
											</MenuItem>
										);
									})}
								</Select>
							) : (
								<Skeleton
									variant="rounded"
									width={380}
									height={40}
									sx={{ borderRadius: "8px" }}
								/>
							)}
						</Box>
					</Box>
					<Box className="adjust-list__body">
						<Box className="adjust-list__body__background">
							<Box className="adjust-list__body__searchrow">
								<TextField
									size="small"
									className="adjust-list__body__searchrow-textfield"
									type="text"
									placeholder="Buscar"
									InputProps={{
										startAdornment: (
											<InputAdornment position="start">
												<Search size={15} />
											</InputAdornment>
										),
									}}
									onChange={(event) => {
										setAreaFilterSelected(event.target.value.toLowerCase());
									}}
								></TextField>
								<Box
									id="onboarding-2"
									className="adjust-list__body__searchrow__buttons_container"
								>
									<Tooltip
										title="Agregar Profesional"
										placement="top"
										arrow
										classes={{
											tooltip:
												"adjust-list__body__searchrow__buttons_container-tooltip",
											arrow: "adjust-list__body__searchrow__buttons_container-tooltip-arrow",
										}}
									>
										<Button
											size="small"
											className="adjust-list__body__searchrow__buttons_container-button"
											onClick={() => {
												setModalHeader("Agregar Profesional");
												setShowModal(true);
											}}
										>
											<Plus />
										</Button>
									</Tooltip>
									<Tooltip
										title="Mover Profesional"
										placement="top"
										arrow
										classes={{
											tooltip:
												"adjust-list__body__searchrow__buttons_container-tooltip",
											arrow: "adjust-list__body__searchrow__buttons_container-tooltip-arrow",
										}}
									>
										<Button
											size="small"
											disabled={selectedNurses.length !== 1}
											className="adjust-list__body__searchrow__buttons_container-button"
											onClick={() => {
												setModalHeader("Mover Profesional");
												setShowModal(true);
											}}
										>
											<ArrowRight
												color={
													selectedNurses.length === 1
														? "#62098C"
														: "#BDBDBD"
												}
											/>
										</Button>
									</Tooltip>
									<Tooltip
										title="Reemplazar Profesional"
										placement="top"
										arrow
										classes={{
											tooltip:
												"adjust-list__body__searchrow__buttons_container-tooltip",
											arrow: "adjust-list__body__searchrow__buttons_container-tooltip-arrow",
										}}
									>
										<Button
											size="small"
											className="adjust-list__body__searchrow__buttons_container-button"
											disabled={selectedNurses.length !== 1}
											onClick={() => {
												setModalHeader("Reemplazar Profesional");
												setShowModal(true);
											}}
										>
											<Repeat
												color={
													selectedNurses.length === 1
														? "#62098C"
														: "#BDBDBD"
												}
											/>
										</Button>
									</Tooltip>
									<Tooltip
										title="Eliminar Profesional"
										placement="top"
										arrow
										classes={{
											tooltip:
												"adjust-list__body__searchrow__buttons_container-tooltip",
											arrow: "adjust-list__body__searchrow__buttons_container-tooltip-arrow",
										}}
									>
										<Button
											size="small"
											className="adjust-list__body__searchrow__buttons_container-button"
											disabled={selectedNurses.length === 0}
											onClick={() => {
												setModalHeader("Eliminar Profesional");
												setShowModal(true);
											}}
										>
											<Trash2
												color={
													selectedNurses.length > 0
														? "#62098C"
														: "#BDBDBD"
												}
											/>
										</Button>
									</Tooltip>
									{loggedUser.position !== Position.SUPER && (
										<Button
											id="onboarding-3"
											className="adjust-list__body__searchrow__buttons_container-continue_button"
											onClick={() => {
												dispatch(setPageState(PageState.Patients));
												dispatch(setIsPatientsEnabled(true));
											}}
										>
											<Check color="white" />
											<Typography>Continuar</Typography>
										</Button>
									)}
								</Box>
							</Box>
							{!isLoading ? (
								<Box className="adjust-list__body__filtersrow">
									{canScrollLeft && (
										<Button
											className="adjust-list__body__filtersrow-leftarrow"
											onClick={() => handleScroll("left")}
										>
											<ChevronLeft />
										</Button>
									)}
									<Box
										ref={containerRef}
										className="adjust-list__body__filtersrow__content"
									>
										{areas
											.sort((a: any, b: any) => a.area.localeCompare(b.area))
											.map((e: any) => {
												return (
													<Button
														sx={{
															backgroundColor:
																areaFilterSelected === e.area
																	? "#f5eff6"
																	: "white",
															color:
																areaFilterSelected === e.area
																	? "#6d247a"
																	: "#bdbdbd",
														}}
														disableRipple
														onClick={() => {
															areaFilter(e.area);
														}}
														className="adjust-list__body__filtersrow__content-pill"
													>
														<Typography>{e.area}</Typography>
													</Button>
												);
											})}
									</Box>
									{canScrollRight && (
										<Button
											onClick={() => handleScroll("right")}
											className="adjust-list__body__filtersrow-rightarrow"
										>
											<ChevronRight />
										</Button>
									)}
								</Box>
							) : (
								<Box className="skeleton__filters-row">
									{Array.from({ length: 8 }).map(() => (
										<Skeleton
											sx={{ borderRadius: "16px" }}
											variant="rounded"
											width={150}
											height={35}
										/>
									))}
								</Box>
							)}
						</Box>
						{!isNursesLoading ? (
							filteredNurses.length > 0 ? (
								<Table className="adjust-list__body__content">
									<TableHead className="adjust-list__body__content__head">
										<TableCell
											onClick={() => {
												if (selectedNurses.length > 0) {
													setSelectedNurses([]);
												} else {
													filteredNurses.forEach((nurse: any) => {
														updateSelectedNurses(nurse.id);
													});
												}
											}}
										>
											<Checkbox
												className="adjust-list__body__content__rows-checkbox"
												checked={
													selectedNurses.length === filteredNurses.length
												}
											/>
										</TableCell>
										<TableCell onClick={() => handleSort("nursename")}>
											Nombre{" "}
											{sortConfig?.key === "nursename" ? (
												sortConfig.direction === "desc" ? (
													<ChevronDown size={18} />
												) : (
													<ChevronUp size={18} />
												)
											) : (
												<ChevronDown size={18} />
											)}
										</TableCell>
										<TableCell onClick={() => handleSort("classx")}>
											Clase{" "}
											{sortConfig?.key === "classx" ? (
												sortConfig.direction === "desc" ? (
													<ChevronDown size={18} />
												) : (
													<ChevronUp size={18} />
												)
											) : (
												<ChevronDown size={18} />
											)}
										</TableCell>
										<TableCell onClick={() => handleSort("vital_support")}>
											Soporte Vital{" "}
											{sortConfig?.key === "vital_support" ? (
												sortConfig.direction === "desc" ? (
													<ChevronDown size={18} />
												) : (
													<ChevronUp size={18} />
												)
											) : (
												<ChevronDown size={18} />
											)}
										</TableCell>
										<TableCell onClick={() => handleSort("area")}>
											Sector{" "}
											{sortConfig?.key === "area" ? (
												sortConfig.direction === "desc" ? (
													<ChevronDown size={18} />
												) : (
													<ChevronUp size={18} />
												)
											) : (
												<ChevronDown size={18} />
											)}
										</TableCell>
										{loggedUser.position === Position.SUPER && (
											<TableCell onClick={() => handleSort("hospital_name")}>
												Hospital{" "}
												{sortConfig?.key === "hospital_name" ? (
													sortConfig.direction === "desc" ? (
														<ChevronDown size={18} />
													) : (
														<ChevronUp size={18} />
													)
												) : (
													<ChevronDown size={18} />
												)}
											</TableCell>
										)}
									</TableHead>
									<TableBody className="adjust-list__body__content__rows">
										{filteredNurses.map((e: any) => {
											return (
												<tr onClick={() => updateSelectedNurses(e.id)}>
													<TableCell>
														<Checkbox
															className="adjust-list__body__content__rows-checkbox"
															checked={selectedNurses.includes(e.id)}
														/>
													</TableCell>
													<TableCell>{capitalize(e.nursename)}</TableCell>
													<TableCell>{e.classx}</TableCell>
													<TableCell>{e.vital_support}</TableCell>
													<TableCell>{e.area}</TableCell>
													{loggedUser.position === Position.SUPER && (
														<TableCell>
															{capitalize(e.hospital_name)}
														</TableCell>
													)}
												</tr>
											);
										})}
									</TableBody>
								</Table>
							) : (
								<Box className="adjust-list__body__content-empty">
									<Typography>Sin profesionales</Typography>
								</Box>
							)
						) : (
							<Table className="adjust-list__body__content">
								<TableHead className="adjust-list__body__content__head">
									<TableCell />
									<TableCell>Nombre</TableCell>
									<TableCell>Clase</TableCell>
									<TableCell>Soporte Vital</TableCell>
									<TableCell>Sector</TableCell>
									{loggedUser.position === Position.SUPER && (
										<TableCell>Hospital</TableCell>
									)}
								</TableHead>
								<TableBody className="adjust-list__body__content__rows">
									{Array.from({ length: 12 }).map((e: any) => {
										return (
											<tr>
												{Array.from({ length: 6 }).map(() => {
													return (
														<TableCell>
															<Skeleton
																variant="text"
																sx={{ fontSize: "14px" }}
															/>
														</TableCell>
													);
												})}
											</tr>
										);
									})}
								</TableBody>
							</Table>
						)}
					</Box>
					<Modal
						open={showModal}
						onClose={clearFieldsNClose}
						className="modal-container"
					>
						<Box>
							<Box className="assistance-modal-card">
								<ModalOption></ModalOption>
							</Box>
							<CustomSnackbar
								open={openSnackbar}
								onClose={() => setOpenSnackbar(false)}
								title="Aviso"
								subtitle="Este profesional ya existe en el turno."
								mode={SnackbarModes.WARNING}
							/>
						</Box>
					</Modal>
				</Box>
				<Modal
					open={showConfirmationModal}
					onClose={clearFieldsNClose}
				>
					<ConfirmationModal title={confirmationTitle} />
				</Modal>
				<ToastContainer
					enableMultiContainer
					containerId={"AAV"}
					autoClose={2000}
					position="top-right"
				></ToastContainer>
			</AssitanceAdjustViewContext.Provider>
		</>
	);
}
